import React from 'react';
import PropTypes from 'prop-types';

import styles from './InformationPage.css';

export const InformationPage = ({ children, title }) => (
  <div className={styles.informationPage}>
    <div className={styles.informationPageBox}>
      <h1 className={styles.informationPageBoxTitle}>{title}</h1>
      <p className={styles.informationPageBoxMessage}>{children}</p>
    </div>
  </div>
);

InformationPage.propTypes = {
  /** @ignore */
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired
};
